import { ActionType } from 'typesafe-actions';
import * as actions from './catalogActions';
import {
    GET_CONTENT_TYPES_REQUEST,
    GET_CONTENT_TYPES_SUCCESS,
    GET_CONTENT_TYPES_FAILURE,
} from './catalogConstants';
import { ContentType } from '../Common/types/CatalogTypes';

export type CatalogAction = ActionType<typeof actions>;

export type CatalogState = Readonly<{
    isLoading: boolean;
    isError: boolean;
    contentTypes: ContentType[];
}>;

const initialState: CatalogState = {
    isLoading: false,
    isError: false,
    contentTypes: [],
};

export default (state: CatalogState = initialState, action: CatalogAction) => {
    switch (action.type) {
        case GET_CONTENT_TYPES_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case GET_CONTENT_TYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                contentTypes: [...action.payload],
            };
        case GET_CONTENT_TYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};
